import React, { useState, useEffect } from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { Form, Container, Row, Col, Card, Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import "../Contact/contact.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";

const FACTURA_URL = "https://auto.factura.com/67d0920e1ccb9";

const Factura = () => {
    const [invoice, setInvoice] = useState('');
    const [amount, setAmount] = useState('');
    const [date, setDate] = useState('');
    const [contactData, setContactData] = useState(null);
    const [showTutorial, setShowTutorial] = useState(false);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchContactData();
    }, []);

    const fetchContactData = async () => {
        try {
            const response = await axios.get(`${ENDPOINT}get-page-contact/1`);
            if (response.data && response.data.res === true) {
                setContactData(response.data.data);
            }
        } catch (error) {
            console.error('Error al cargar los datos de contacto:', error);
        }
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        const params = new URLSearchParams({ order: invoice, amount, date });
        window.location.assign(`${FACTURA_URL}?${params.toString()}`);
    };

    return (
        <>
            <ProgressBarLoader />
            <Breadcrumbs title="Factura" pagename="Factura" />
            <section className="contact pt-1">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="main_heading text-center">
                                <h1 className="text-uppercase">FACTURAS SALINACRUCENSES</h1>
                                <h6 className="h6 text-uppercase mt-3">GENERA TUS FACTURAS CON ESTOS SENCILLOS PASOS</h6>
                            </div>
                        </Col>
                    </Row>

                    <Row className="py-4">
                        <Col lg="6" md="6" className="mb-4 mb-lg-0">
                            <Card className="border shadow rounded-3 mb-4 card-equal-height">
                                <Card.Body className="text-center">
                                    <div className="d-flex justify-content-center align-item-search my-2">
                                        <div className="bg-info rounded-circle text-info shadow-sm bg-opacity-10 p-2">
                                            <i className="bi bi-receipt h3"></i>
                                        </div>
                                    </div>
                                    <p className="mb-3 body-text" style={{ whiteSpace: 'pre-line' }}>
                                        {contactData?.card_1}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg="6" md="6" className="mb-4 mb-lg-0">
                            <Card className="border shadow rounded-3 mb-4 card-equal-height">
                                <Card.Body className="text-center">
                                    <div className="d-flex justify-content-center align-item-search my-2">
                                        <div className="bg-danger rounded-circle text-danger shadow-sm bg-opacity-10 p-2">
                                            <i className="bi bi-exclamation-circle h3"></i>
                                        </div>
                                    </div>
                                    <p className="mb-3 body-text" style={{ whiteSpace: 'pre-line' }}>
                                        {contactData?.card_2}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="pb-4 position-relative" style={{ zIndex: 2 }}>
                        <Col md="12" className="text-center">
                            <Button
                                variant="primary"
                                size="lg"
                                className="px-4 shadow"
                                onClick={() => setShowTutorial(true)}
                            >
                                <i className="bi bi-play-circle me-2"></i>
                                Ver tutorial
                            </Button>
                        </Col>
                    </Row>

                    <Modal
                        show={showTutorial}
                        onHide={() => setShowTutorial(false)}
                        centered
                        size="lg"
                        aria-labelledby="tutorial-modal-title"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="tutorial-modal-title">Tutorial de facturación</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-2 p-md-3">
                            <div className="ratio ratio-16x9 rounded overflow-hidden">
                                <iframe
                                    src="https://www.youtube.com/embed/_4PhfAAJOS0?si=jUu9IOCTFvn_xFFa"
                                    title="Tutorial de facturación"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                    style={{ border: 0 }}
                                ></iframe>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Row className="justify-content-center mt-4 mb-5">
                        <Col md="8" lg="6">
                            <Card className="border shadow rounded-3">
                                <Card.Body className="p-4">
                                    <h2 className="h4 text-center mb-4">Ingresa los datos de tu compra</h2>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3" controlId="invoiceOrder">
                                            <Form.Label>Folio</Form.Label>
                                            <Form.Control
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]+"
                                                value={invoice}
                                                onChange={(event) => setInvoice(event.target.value.replace(/\D/g, ''))}
                                                placeholder="Solo números"
                                                required
                                            />
                                            <Form.Text muted>El folio debe contener únicamente números.</Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="invoiceAmount">
                                            <Form.Label>Monto</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="0.01"
                                                step="0.01"
                                                value={amount}
                                                onChange={(event) => setAmount(event.target.value)}
                                                placeholder="Ej. 1500.50"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-4" controlId="invoiceDate">
                                            <Form.Label>Fecha de compra</Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={date}
                                                onChange={(event) => setDate(event.target.value)}
                                                required
                                            />
                                        </Form.Group>
                                        <div className="text-center">
                                            <Button type="submit" variant="primary" size="lg" className="px-4 shadow">
                                                <i className="bi bi-box-arrow-up-right me-2"></i>
                                                Continuar a facturación
                                            </Button>
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Factura;